// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d2e73655","239":"352483c0","453":"31ae665a","455":"927aad05"}[chunkId] + ".chunk.js";
};